import React from "react";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";

const Footer = () => {
    const { t } = useTranslation()
    
    return (
        <footer className="footer">
            <div className="container">
                <div className="row">
                    <div className="col-md-4 mb-4 mb-md-0">
                        <h4>Torgyd</h4>
                        <p className="text-muted">{t('footer-tagline')}</p>
                    </div>
                    <div className="col-md-4 mb-4 mb-md-0">
                        <h4>Links</h4>
                        <ul className="list-unstyled">
                            <li><Link to="/about">{t('footer-about')}</Link></li>
                            <li><Link to="/safety">{t('footer-safety')}</Link></li>
                            <li><Link to="/privacy">{t('footer-privacy')}</Link></li>
                        </ul>
                    </div>
                    <div className="col-md-4">
                        <h4>{t('footer-socials')}</h4>
                        <div className="d-flex gap-3">
                            <a 
                                href="https://twitter.com/vallard"
                                rel="noopener noreferrer"
                                target="_blank"
                                aria-label="Twitter"
                            >
                                <i className="bi bi-twitter" style={{ fontSize: '1.5rem' }}></i>
                            </a>
                            <a 
                                href="https://www.linkedin.com/in/vallard/"
                                rel="noopener noreferrer"
                                target="_blank"
                                aria-label="LinkedIn"
                            >
                                <i className="bi bi-linkedin" style={{ fontSize: '1.5rem' }}></i>
                            </a>
                        </div>
                        <p className="text-muted mt-3 small">
                            © {new Date().getFullYear()} Torgyd. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
